import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ExpiredListingsSearchTable from './components/ExpiredListingsSearchTable';
import MyAlerts from '../MyAlerts';
import TrialAlert from '../../shared/components/payment/TrialAlert';
import EnterpriseGate from '../../shared/components/payment/EnterpriseGate';
import { _hasPermission } from "../../shared/helpers/access";
import CalloutBanner from '../../shared/components/CalloutBanner';

import {
  isMobile,
} from "react-device-detect";

class ExpiredListings extends React.Component {
	constructor(props) {
	    super(props);
	    this.state = {};
	}

	componentDidMount() {
	  console.log('componentDidMount Expired Listings');
	}

	render() {
		const { user } = this.props;
	    if (!user) {
			return (
				<Container>
					<Row>
						<Col md={12}>
							<h3 className="page-title">Expired Listings</h3>
							<p>Loading...</p>
						</Col>
					</Row>
				</Container>
			);
		}

		const requestedTab = (this.props.match && this.props.match.params && this.props.match.params.tab) || 'search';
		const tab = requestedTab;
		const isAlerts = tab === 'alerts';

		const goToTab = (next) => {
			if (next === tab) return;
			this.props.history.push(next === 'alerts' ? '/expired-listings/alerts' : '/expired-listings');
		};

		const tabs = [{ key: 'search', label: 'Search' }, { key: 'alerts', label: 'My Alerts' }];

		return (
		  <Container>
		    <Row>
		      <Col md={12}>
		        <h3 className="page-title">Expired Listings</h3>
		        {!isMobile && <h3 className="page-subhead subhead">Find properties that have gone off the market</h3>}
		      </Col>
		    </Row>
		    {_hasPermission(user, 'owner-outreach') ?
			   <Fragment>
			     <Row>
			      <Col md={12} className={'mb-3'}>
			       	<TrialAlert />
			      </Col>
			    </Row>

				<CalloutBanner
				  storageKey="mp_expired_listings_banner_v1"
				  variant="purple"
				>
				  {function () {
					return (
					  <div className="d-flex justify-content-between align-items-center flex-wrap">
						<div>
						  <p className="callout-banner-title">
							<img
							  src="https://marketproof.com/images/new-red.png"
							  alt=""
							  style={{ marginRight: 6 }}
							/>
							Expired Listings Outreach
						  </p>

						  <p className="callout-banner-sub-title mb-2">
							Find properties that went off market or with expired listing contracts. Target motivated sellers before they relist.
						  </p>
						</div>

						<div className="align-items-center mt-2 text-right">
						  <a
							href="https://help.marketproof.com/en/articles/13744253-expired-listings"
							target="_blank"
							rel="noopener noreferrer"
							className="btn btn-primary mb-2 callout-banner-btn"
						  >
							Learn more
						  </a>
						</div>
					  </div>
					);
				  }}
				</CalloutBanner>

				{tabs.length > 1 && (
					<Row>
						<Col md={12}>
							<div style={{ display: 'flex', marginBottom: 16, borderBottom: '2px solid #e8e8e8' }}>
								{tabs.map(t => {
									const active = (t.key === 'alerts') === isAlerts;
									return (
										<Button
											key={t.key}
											onClick={() => goToTab(t.key)}
											style={{
												borderRadius: 0,
												borderBottom: active ? '3px solid #780F9E' : '3px solid transparent',
												color: active ? '#780F9E' : '#646777',
												fontWeight: active ? 600 : 400,
												fontSize: 15,
												textTransform: 'uppercase',
												padding: '8px 20px',
												minWidth: 0,
												marginBottom: -2
											}}
										>
											{t.label}
										</Button>
									);
								})}
							</div>
						</Col>
					</Row>
				)}

				{!isAlerts && (
					<Row>
						<ExpiredListingsSearchTable />
					</Row>
				)}
				{isAlerts && (
					<Row>
						<Col md={12}>
							<MyAlerts />
						</Col>
					</Row>
				)}
		    </Fragment>
		    :
			     <Row>
				   <EnterpriseGate
				   copy={<span>Access to Expired Listings requires an upgrade to your subscription.</span>}
				   upgrade={true}
				   user={user}
				   nextPlan={"complete"} />
				 </Row>
			}
		  </Container>
		);
	}
};

export default withRouter(connect(state => ({
  user: state.user,
}))(ExpiredListings));
